// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Hooks = require("../../../utils/Hooks.bs.js");
let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let Features = require("../../../reason/featureFlipper/Features.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let DebounceP = require("../../../reason/common/DebounceP.bs.js");
let OptionExt = require("../../common/OptionExt.bs.js");
let SearchField = require("../../../reason/chapter/components/SearchField.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReadMoreButton = require("../../../components/buttons/ReadMoreButton.bs.js");
let QuestionPopover = require("../../../components/MyClientsWidget/components/QuestionPopover/QuestionPopover.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let MyClientsWidgetBuyer = require("./MyClientsWidgetBuyer.bs.js");
let MyClientsWidgetRenter = require("./MyClientsWidgetRenter.bs.js");
let MyClientsWidgetSeller = require("./MyClientsWidgetSeller.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyClientsWidgetLandlord = require("./MyClientsWidgetLandlord.bs.js");
let MyClientsWidgetDeveloper = require("./MyClientsWidgetDeveloper.bs.js");
let MyClientsWidgetQueryParams = require("./MyClientsWidgetQueryParams.bs.js");
let MyClientsWidgetRelay_query_graphql = require("../../../__generated__/MyClientsWidgetRelay_query_graphql.bs.js");
let MyClientsWidgetRelayPaginationQuery_graphql = require("../../../__generated__/MyClientsWidgetRelayPaginationQuery_graphql.bs.js");

function MyClientsWidgetRelay$AddClientMenu(props) {
  let button = Hooks.useResponsive(JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
    size: "small",
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: "add",
        size: 14
      }),
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Add client"
      })
    ]
  }), JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    size: "small",
    children: "Add Client"
  }), undefined, undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs(MenuV5.Menu.make, {
    button: button,
    children: [
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/sellers/new",
        children: "Add seller quietly"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/properties/new",
        children: "Broadcast a property"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/private_buyers/new",
        children: "Add buyer quietly"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/client_needs/new",
        children: "Broadcast a buyer or rental need"
      })
    ]
  });
}

let AddClientMenu = {
  make: MyClientsWidgetRelay$AddClientMenu
};

let getConnectionNodes = MyClientsWidgetRelay_query_graphql.Utils.getConnectionNodes;

let convertFragment = MyClientsWidgetRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRelay_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = MyClientsWidgetRelayPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = MyClientsWidgetRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyClientsWidgetRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyClientsWidgetRelay_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyClientsWidgetRelay$Layout(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "My Clients",
                className: "text-gray-700 text-2xl font-medium"
              }),
              JsxRuntime.jsxs(QuestionPopover.make, {
                children: [
                  "Keep track of your clients and activity on TAN.",
                  " ",
                  JsxRuntime.jsx("a", {
                    children: "Read more.",
                    href: "https://intercom.help/top-agent-network/faqs-and-troubleshooting/my-clients",
                    target: "_blank"
                  })
                ]
              })
            ],
            className: "flex flex-row items-center gap-4"
          }),
          JsxRuntime.jsx(MyClientsWidgetRelay$AddClientMenu, {})
        ],
        className: "flex flex-row pb-[15px] items-center justify-between"
      }),
      props.children
    ],
    className: "bg-white p-5 rounded shadow-sm"
  });
}

let Layout = {
  make: MyClientsWidgetRelay$Layout
};

function MyClientsWidgetRelay$EmptyState(props) {
  return JsxRuntime.jsx("div", {
    children: "When you add your clients to TAN, they'll appear here. This makes it easy to track your clients, edit posts and evaluate matches.",
    className: "p-5 border border-gray-300 text-base leading-5 rounded"
  });
}

let EmptyState = {
  make: MyClientsWidgetRelay$EmptyState
};

function MyClientsWidgetRelay$EmptySearchState(props) {
  return JsxRuntime.jsx("div", {
    children: "No clients match your search.",
    className: "p-5 border border-gray-300 text-base leading-5 rounded"
  });
}

let EmptySearchState = {
  make: MyClientsWidgetRelay$EmptySearchState
};

function MyClientsWidgetRelay$Widget(props) {
  let viewMoreMode = props.viewMoreMode;
  let match = usePagination(props.query);
  let refetch = match.refetch;
  let isLoadingNext = match.isLoadingNext;
  let hasNext = match.hasNext;
  let loadNext = match.loadNext;
  let data = match.data;
  let match$1 = React.useTransition();
  let startTransition = match$1[1];
  let isRefetching = match$1[0];
  let match$2 = MyClientsWidgetQueryParams.use();
  let setQueryParams = match$2[1];
  let queryParams = match$2[0];
  let items = getConnectionNodes(data.accountClientsV5);
  let connectionId = Stdlib_Option.map(data.accountClientsV5, param => param.__id);
  let showSearchField = Features.useFeatureFlipper("ClientsSearch") === "on";
  let match$3 = React.useState(() => Stdlib_Option.getOr(queryParams.clientSearchTerm, ""));
  let setSearchFieldValue = match$3[1];
  let searchFieldValue = match$3[0];
  let searchPageSize;
  searchPageSize = viewMoreMode === "ShowAllButton" ? 7 : 30;
  let activeSearchTerm = OptionExt.ofString(searchFieldValue.trim());
  let refetchSearchResults = React.useCallback(DebounceP.make(300, async searchTerm => startTransition(() => {
    setQueryParams("replace", {
      clientSearchTerm: OptionExt.ofString(searchTerm.trim())
    });
    refetch(makeRefetchVariables(Primitive_option.some(undefined), Primitive_option.some(searchPageSize), Primitive_option.some(OptionExt.ofString(searchTerm.trim())), undefined), undefined, undefined);
  })), [
    refetch,
    startTransition
  ]);
  let tmp;
  if (isRefetching) {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else if (items.length !== 0) {
    let tmp$1;
    tmp$1 = viewMoreMode === "ShowAllButton" ? (
        hasNext ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ReadMoreButton.make, {
              href: activeSearchTerm !== undefined ? `/my_clients?` + MyClientsWidgetQueryParams.toQueryString({
                  clientSearchTerm: activeSearchTerm
                }) : "/my_clients",
              children: "View All"
            }),
            className: "mt-4"
          }) : null
      ) : (
        hasNext && !isLoadingNext ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => {
                loadNext(15, undefined);
              },
              className: "w-full",
              children: "See More Clients"
            }),
            className: "mt-4"
          }) : null
      );
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("ul", {
          children: items.map(item => {
            switch (item.__typename) {
              case "Buyer" :
                return JsxRuntime.jsx(MyClientsWidgetBuyer.make, {
                  buyer: item.fragmentRefs,
                  connectionId: connectionId
                }, item.id);
              case "Developer" :
                return JsxRuntime.jsx(MyClientsWidgetDeveloper.make, {
                  developer: item.fragmentRefs,
                  connectionId: connectionId
                }, item.id);
              case "Landlord" :
                return JsxRuntime.jsx(MyClientsWidgetLandlord.make, {
                  landlord: item.fragmentRefs,
                  connectionId: connectionId
                }, item.id);
              case "Renter" :
                return JsxRuntime.jsx(MyClientsWidgetRenter.make, {
                  renter: item.fragmentRefs,
                  connectionId: connectionId
                }, item.id);
              case "Seller" :
                return JsxRuntime.jsx(MyClientsWidgetSeller.make, {
                  seller: item.fragmentRefs,
                  connectionId: connectionId
                }, item.id);
              case "__unselected" :
                return null;
            }
          }),
          className: "flex flex-col border-b mb-6 divide-y border-t"
        }),
        tmp$1
      ]
    });
  } else {
    tmp = activeSearchTerm !== undefined ? JsxRuntime.jsx(MyClientsWidgetRelay$EmptySearchState, {}) : JsxRuntime.jsx(MyClientsWidgetRelay$EmptyState, {});
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      showSearchField ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SearchField.make, {
              value: searchFieldValue,
              placeholder: "Search by name, email or address...",
              isLoading: isRefetching,
              onChange: evt => {
                let value = evt.target.value;
                setSearchFieldValue(param => value);
                refetchSearchResults(value);
              },
              size: "md",
              rounded: true
            }),
            className: "flex-1"
          }),
          className: "mb-4 flex items-center gap-4"
        }) : null,
      tmp,
      isLoadingNext && !isRefetching ? JsxRuntime.jsx(Loader.make, {}) : null
    ]
  });
}

let Widget = {
  make: MyClientsWidgetRelay$Widget
};

function MyClientsWidgetRelay(props) {
  let showSearchField = Features.useFeatureFlipper("ClientsSearch") === "on";
  let loadingHeight = showSearchField ? "h-[826px]" : "h-[767px]";
  return JsxRuntime.jsx(MyClientsWidgetRelay$Layout, {
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(MyClientsWidgetRelay$Widget, {
        query: props.query,
        viewMoreMode: props.viewMoreMode
      }),
      fallback: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Loader.make, {
          loadingText: "Loading clients..."
        }),
        className: "flex items-center justify-center " + loadingHeight
      })
    })
  });
}

let Landlord;

let Seller;

let Buyer;

let Renter;

let Developer;

let QueryParams;

let make = MyClientsWidgetRelay;

exports.Landlord = Landlord;
exports.Seller = Seller;
exports.Buyer = Buyer;
exports.Renter = Renter;
exports.Developer = Developer;
exports.QueryParams = QueryParams;
exports.AddClientMenu = AddClientMenu;
exports.QueryFragment = QueryFragment;
exports.Layout = Layout;
exports.EmptyState = EmptyState;
exports.EmptySearchState = EmptySearchState;
exports.Widget = Widget;
exports.make = make;
/* Hooks Not a pure module */
